<template>
  <div id="dev-footer" class="dev-footer" v-if="showDevFooter">
    <mobile-orientation></mobile-orientation>
    <span id="dev-fetch-status" class="dev-fetch-status"></span>
    <div id="dev-video" class="" :key="videoFile">
      <div>
        <video controls autoplay name="media" preload="none">
          <source :src="videoFile" type="video/mp4" />
          <!-- <source :src="videoFile" type="video/ogg" /> -->
          Your browser does not support the video tag.
        </video>
      </div>
      <button @click="changeFilm()">Chnage Video</button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { getVideoURL } from '../DB/get';
import { VIDEO_NAMES } from '../DB/configDB';
import MobileOrientation from '../Mobile/MobileOrientation/MobileOrientation';
export default {
  name: 'dev-footer',
  components: {
    MobileOrientation,
  },
  data() {
    return {
      videoFile: '',
      publicPath: process.env.BASE_URL,
    };
  },
  mounted() {
    let name = '/static/media/films/page008/008 sem2_tab38_tranzyt wenus.mp4';
    this.changeFilm(name);
  },
  methods: {
    changeFilm(_name) {
      let name = _name;
      if (!name) {
        name = _.sample(VIDEO_NAMES);
        console.log('name', name);
      }
      return getVideoURL(name).then((videURL) => {
        console.log('videURL', videURL);
        this.videoFile = videURL;
      });
    },
  },
  computed: {
    showDevFooter() {
      return this.$store.getters.showDevFooter;
    },
  },
};
</script>

<style lang="scss">
.dev-footer {
  height: 20%;
  width: 100%;
  position: absolute;
  top: 0%;
  left: 0%;
  #dev-video {
    position: absolute;
    top: 0;
    left: 42%;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
